
import './LoadingAnimation.css';

export default function LoadingAnimation( props) {
  return <img className='LoadingAnimation' src='/resources/loading-spinning-bubbles.svg' />;
}
